//@ts-check

var consts = require("./consts")

var notSupprortedSteps = [
  consts.STEP_TYPES.MATCH_ABI,
  consts.STEP_TYPES.EXECUTE_JS_FUNCTION,
  consts.STEP_TYPES.DOES_NOT_MATCH_ABI,
  consts.STEP_TYPES.REGEXP,
  consts.STEP_TYPES.MINT_ERC20,
]
module.exports = function isEditableTest(test) {
  if (!test.steps) {
    return false
  }
  if (test.steps.find(step => notSupprortedSteps.includes(step.type)))
    return false
  if (test.steps.find(step => step.required_output)) return false
  return true
}
